import React from 'react';

const MaintenancePage = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Maintenance</h1>
        <p className="text-gray-600 mt-2">We'll be back soon</p>
      </div>
      
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-700">
          This is the Maintenance page. Content will be implemented here.
        </p>
      </div>
    </div>
  );
};

export default MaintenancePage;
